import { Action, createReducer, on } from '@ngrx/store';

import {
  initialState,
  EntityPersonasFisicaState
} from './entity-personas-fisica.state';
import { entityPersonasFisicaAdapter } from './entity-personas-fisica.state';
import {
  entityPersonasFisicaLoadRequest,
  entityPersonasFisicaLoadSuccess,
  entityPersonasFisicaLoadFailure,
  entityPersonasFisicaAddFailure,
  entityPersonasFisicaAddRequest,
  entityPersonasFisicaAddSuccess,
  entityPersonasFisicaChangeFailure,
  entityPersonasFisicaChangeRequest,
  entityPersonasFisicaChangeSuccess,
  entityPersonasFisicaDeleteFailure,
  entityPersonasFisicaDeleteRequest,
  entityPersonasFisicaDeleteSuccess
} from './entity-personas-fisica.actions';
import { createPersonaFisica } from './entity-personas-fisica.model';

const reducer = createReducer(
  initialState,
  // load
  on(entityPersonasFisicaLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityPersonasFisicaLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityPersonasFisicaLoadSuccess, (state, { items }) =>
    entityPersonasFisicaAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // add
  on(entityPersonasFisicaAddRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityPersonasFisicaAddFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityPersonasFisicaAddSuccess, (state, { item }) =>
    entityPersonasFisicaAdapter.addOne(item.persona_fisica, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // change
  on(entityPersonasFisicaChangeRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityPersonasFisicaChangeFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityPersonasFisicaChangeSuccess, (state, { item }) =>
    entityPersonasFisicaAdapter.upsertOne(item.persona, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // delete
  on(entityPersonasFisicaDeleteRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityPersonasFisicaDeleteFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityPersonasFisicaDeleteSuccess, (state, { item }) =>
    entityPersonasFisicaAdapter.removeOne(item.id, {
      ...state,
      isLoading: false,
      error: null
    })
  )
);

export function personasFisicaReducer(
  state: EntityPersonasFisicaState | undefined,
  action: Action
) {
  return reducer(state, action);
}
